interface EchoConfig {
  broadcaster: string;
  key?: string;
  wsHost?: string;
  wsPort?: number;
  wssPort?: number;
  forceTLS?: boolean;
  enabledTransports?: string[];
}

interface EchoInstance {
  private(channel: string): {
    listen(event: string, callback: (data: unknown) => void): void;
    leave(): void;
  };
  disconnect(): void;
}

let echoInstance: EchoInstance | null = null;

export const initEcho = (): EchoInstance => {
  if (echoInstance) {
    return echoInstance;
  }

  const config: EchoConfig = {
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY || '',
    wsHost: import.meta.env.VITE_REVERB_HOST || 'localhost',
    wsPort: Number(import.meta.env.VITE_REVERB_PORT) || 8080,
    wssPort: Number(import.meta.env.VITE_REVERB_PORT) || 8080,
    forceTLS: import.meta.env.VITE_REVERB_SCHEME === 'https',
    enabledTransports: ['ws', 'wss'],
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Echo = (window as any).Echo;
  if (Echo) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    echoInstance = Echo(config) as any;
  }

  return echoInstance as EchoInstance;
};

export const getEcho = (): EchoInstance | null => echoInstance;

export default { initEcho, getEcho };
